import { APIService, FetchListRequest } from "@/services/api";
import { API } from "@/lib/api";
import { ReadProjectRole, WriteProjectRole } from "@/types/projectRoleType";

const ProjectService = new APIService<ReadProjectRole, WriteProjectRole>(
  API.Projects,
);

export const ProjectRolesService = {
  getList: (
    projectId: string,
    fetchParams?: FetchListRequest<ReadProjectRole>,
  ) => ProjectService.getList(fetchParams, `/${projectId}/roles`),
  get: (projectId: string, roleId: string) =>
    ProjectService.get<ReadProjectRole>(`${projectId}/roles/${roleId}`),
  patch: (projectId: string, roleId: string, values: WriteProjectRole) =>
    ProjectService.patch(projectId, values, `roles/${roleId}`),
  post: (projectId: string, values: WriteProjectRole) =>
    ProjectService.post(values, `${projectId}/roles`),
};
